/**
 * Reine Regeln des Dialogs „Projekt verknuepfen" (ProjectLinkingModal.tsx).
 *
 * Ausgelagert, weil vitest hier ohne jsdom laeuft: was der Dialog anzeigt und
 * wonach er sucht, soll ohne Supabase und ohne gerenderte Komponente
 * pruefbar sein.
 */
import type { ReportMetadata } from '../types';

/** Das Projekt, das Tochter werden soll — so, wie ProjectHub es hereinreicht. */
export interface VerknuepfungsProjekt {
    id?: string;
    name?: string | null;
    data?: { metadata?: ReportMetadata };
}

/** Steht weder Spaltenname noch Projektname da, liest der Satz trotzdem. */
export const OHNE_PROJEKTNAME = 'dieses Projekt';

/**
 * Der Name im Hinweis „Sie definieren … als Tochterprojekt".
 *
 * ProjectHub reicht `{ id, data: report }` herein, also den geoeffneten
 * Bericht und KEINE Projektzeile — `name` fehlt dort, und der Satz stand bis
 * hierher mit leerer Stelle da. Der Projektname steht im Bericht unter
 * `metadata.projectName`; aus ihm schreibt der Speicherweg auch die Spalte
 * `projects.name` (cloudService, commonPayload). `name` hat Vorrang, falls ein
 * kuenftiger Aufrufer die Spalte mitgibt. Leerer Text zaehlt wie fehlend:
 * `??` liesse einen leeren Spaltenwert durch und die Luecke stuende wieder da.
 */
export const anzeigeNameAktuellesProjekt = (projekt: VerknuepfungsProjekt | null | undefined): string =>
    projekt?.name?.trim() || projekt?.data?.metadata?.projectName?.trim() || OHNE_PROJEKTNAME;

/**
 * Trifft ein Listeneintrag die Suche nach einem Mutterprojekt?
 *
 * Name (ohne Gross-/Kleinschreibung) oder Projektnummer (wortgleich, wie
 * bisher). `projects.name` ist nullbar (listProject.ts): ein Eintrag ohne
 * Namen liess die ganze Suche mit einem TypeError abbrechen — jetzt faellt er
 * nur beim Namen durch und ist ueber die Nummer weiter auffindbar.
 */
export const passtZurMutterSuche = (
    projekt: { name?: string | null; project_number?: string | null },
    suche: string,
): boolean =>
    (projekt.name ?? '').toLowerCase().includes(suche.toLowerCase())
    || (!!projekt.project_number && projekt.project_number.includes(suche));
